<deposit-end-screen-wrapper class="bp-modal mod-lg">
	<bp-modal-header header [title]="'deposit' | translate"></bp-modal-header>
	<div content class="end-screen-content">
		<img class="end-screen-img" src="/assets/images/success.svg" [alt]="'deposit_successful_title' | translate" />
		<div class="end-screen-headline">{{ "deposit_successful_title" | translate }}</div>
		<p class="end-screen-description">{{ "deposit_successful_subtitle" | translate }}</p>
		<div class="end-screen-buttons-container">
			<button type="button" class="btn btn-primary" (click)="close()">{{ "done" | translate }}</button>
		</div>
	</div>
</deposit-end-screen-wrapper>
